import { useState } from "react";
import { storeApiKey, clearApiKey } from "../../src/services/pdf-scanner";

interface ApiKeyModalProps {
    existingKey: string | null;
    onSave: (key: string) => void;
    onClose: () => void;
}

export function ApiKeyModal({ existingKey, onSave, onClose }: ApiKeyModalProps) {
    const [value, setValue] = useState(existingKey ?? "");
    const [error, setError] = useState("");

    const handleSave = () => {
        const trimmed = value.trim();
        if (!trimmed.startsWith("sk-ant-")) {
            setError("Key should start with sk-ant-");
            return;
        }
        storeApiKey(trimmed);
        onSave(trimmed);
    };

    const handleClear = () => {
        clearApiKey();
        setValue("");
        onClose();
    };

    return (
        <div className="confirm-modal-overlay" onClick={onClose}>
            <div className="confirm-modal api-key-modal" onClick={(e) => e.stopPropagation()}>
                <h3 className="confirm-modal-title">Connect Anthropic API Key</h3>
                <p className="api-key-modal-description">
                    SeeTex uses Claude to read and convert PDF pages into LaTeX.
                    Your key is stored locally in your browser — never sent to any server other than Anthropic.
                </p>
                <a
                    className="api-key-modal-link"
                    href="https://console.anthropic.com/settings/keys"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Get a key at console.anthropic.com →
                </a>
                <input
                    className="input-modal-field api-key-modal-input"
                    type="password"
                    placeholder="sk-ant-..."
                    value={value}
                    onChange={(e) => { setValue(e.target.value); setError(""); }}
                    onKeyDown={(e) => e.key === "Enter" && handleSave()}
                    autoFocus
                />
                {error && <p className="api-key-modal-error">{error}</p>}
                <div className="confirm-modal-actions">
                    {existingKey && (
                        <button className="confirm-modal-cancel api-key-modal-danger" onClick={handleClear}>
                            Remove key
                        </button>
                    )}
                    <button className="confirm-modal-cancel" onClick={onClose}>Cancel</button>
                    <button className="confirm-modal-confirm confirm-modal-confirm--primary" onClick={handleSave}>
                        Save &amp; Scan
                    </button>
                </div>
            </div>
        </div>
    );
}
